import { NavLink } from "react-router-dom";
import { Home, LineChart, UtensilsCrossed, User } from "lucide-react";
import { NovaOrb } from "./NovaOrb";

const items = [
  { to: "/app/plan", label: "Today", icon: Home, testId: "bottom-nav-today" },
  { to: "/app/progress", label: "Progress", icon: LineChart, testId: "bottom-nav-progress" },
  { to: "/app/nova", label: "Nova", icon: null, testId: "bottom-nav-nova" },
  { to: "/app/meals", label: "Meals", icon: UtensilsCrossed, testId: "bottom-nav-meals" },
  { to: "/app/profile", label: "Profile", icon: User, testId: "bottom-nav-profile" },
];

export const BottomNav = () => {
  return (
    <nav
      className="fixed bottom-0 inset-x-0 z-40 backdrop-blur-2xl bg-kaizen-bg/85 border-t border-white/[0.06]"
      data-testid="bottom-nav"
    >
      <div className="max-w-md mx-auto flex items-center justify-between px-5 pt-2 pb-[calc(0.6rem+env(safe-area-inset-bottom))]">
        {items.map(({ to, label, icon: Icon, testId }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={testId}
            className={({ isActive }) =>
              `flex flex-col items-center gap-1 px-2 py-1 transition-colors duration-300 ${
                isActive ? "text-kaizen-violetSoft" : "text-kaizen-dim2"
              }`
            }
          >
            {Icon ? (
              <Icon size={20} strokeWidth={1.75} />
            ) : (
              <NovaOrb size={20} pulse={false} testId="bottom-nav-nova-orb" />
            )}
            <span className="text-[11px] tracking-wide font-medium">{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
};
